import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';

import { TreeColors } from '../../../../core/config/mainTheme';
import { toCssValue } from '../../../../core/utils/theme.utils';
import { TreeItem } from '../Tree.types';
import { renderCheckboxIcon } from '../Tree.utils';
import TreeCheckbox from '../TreeCheckbox';

interface Props {
  item: TreeItem;
  treeId: string;
  onCheck: () => void;
}

const TreeItemLabel: React.FC<Props> = React.memo(({ item, treeId, onCheck }) => {
  const classes = useStyles();

  const inputId = `${treeId}-${String(item.id).split(' ').join('_')}`;
  const labelClass = classNames({
    [classes.labelChecked]: item.checkState === 1,
  });

  return (
    <label className={labelClass} key={0} htmlFor={inputId}>
      <TreeCheckbox
        checked={item.checkState === 1}
        id={inputId}
        indeterminate={String(item.checkState === 2)}
        onClick={onCheck}
        onChange={() => {}}
      />
      <span className={classes.checkbox}>{renderCheckboxIcon(item)}</span>
      <span key={1} className={classes.title}>
        {item.name}
      </span>
    </label>
  );
});

const useStyles = makeStyles((theme) => ({
  title: {
    display: 'block',
    padding: toCssValue([theme.spacing(3), theme.spacing(3), theme.spacing(3), 32]),
    lineHeight: 1.2,
  },
  labelChecked: {
    background: TreeColors.checked,

    '&:hover': {
      background: TreeColors.checkedHover,
    },
  },
  checkbox: {
    position: 'absolute',
    width: '30px',
    height: '28px',
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(1),
  },
}));

export default TreeItemLabel;
